import React, { useEffect, useState } from "react";
import { CMSPageDetails } from "../services/website.services";

const sections = [
  { title: "1. Acceptance of Terms", content: "By using our platform, you confirm that you are legally able to enter into this agreement. If you do not agree, please discontinue use." },
  { title: "2. Account Responsibilities", content: "You are responsible for maintaining the confidentiality of your account credentials and all activity under your account." },
  { title: "3. Acceptable Use", content: "You agree not to misuse the platform or use services for unlawful activities. We may suspend accounts that violate these terms." },
  { title: "4. Subscriptions and Billing", content: "Plans may auto-renew unless canceled before renewal date. Fees are non-refundable unless required by law." },
  { title: "5. Intellectual Property", content: "All platform content and branding are owned by us. You may not reproduce or distribute any content without written permission." },
  { title: "6. Limitation of Liability", content: "The platform is provided on an as-is basis. We are not liable for indirect or consequential damages from use of the platform." },
  { title: "7. Changes to Terms", content: "We may revise these terms from time to time. Continued use after updates constitutes acceptance of the revised terms." },
]

export default function WebsiteTermsPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    CMSPageDetails("terms_and_conditions_web", "website").then((res) => {
      if (res.data) {
        setData(res.data);
      }
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="swayyd-section" style={{ paddingTop: "120px" }}>
      <div className="legal-wrapper">
        <div className="legal-header">
          <span className="section-eyebrow">Legal</span>
          <h1 className="section-title">
            {data?.title ? data.title : <>Terms & <em>Conditions</em></>}
          </h1>
          <p className="section-sub">
            {data?.short_description || "Please read these terms carefully before using our platform."}
          </p>
          <p style={{ fontSize: "13px", color: "var(--faint)", fontWeight: 500 }}>
            Last updated: {data?.updatedAt ? new Date(data.updatedAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "March 26, 2026"}
          </p>
        </div>

        <div className="legal-card">
          {data?.description ? (
            <div className="legal-content" dangerouslySetInnerHTML={{ __html: data.description }} />
          ) : (
            <div className="legal-content">
              {sections.map((s, i) => (
                <div key={i} style={{ marginBottom: "24px" }}>
                  <h2>{s.title}</h2>
                  <p>{s.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
